export default "__VITE_ASSET__CERJ4lC6__"